import actionTypes from 'SRC/modules/redux/actionTypes'

export const setPriceTypes = (priceTypes) => ({
  type: actionTypes.SET_PRICE_TYPES,
  payload: priceTypes
})
